import { useAppSelector } from '@/redux/hooks'
import { USER_ROLE } from '@/types/user-profile'
import { useUserProfile } from './useUserProfile'

interface IFollowParams {
  role: USER_ROLE
  id: string
}

const useFollowParams = (): IFollowParams => {
  const { memberInfoId, roles } = useAppSelector((state) => state.member.memberData)
  const { userProfile } = useUserProfile({ memberInfoId })
  const rolesSet = new Set(roles)

  const role = (() => {
    if (rolesSet.has(USER_ROLE.MERCHANT)) {
      return USER_ROLE.MERCHANT
    } else if (rolesSet.has(USER_ROLE.KOL)) {
      return USER_ROLE.KOL
    } else {
      return USER_ROLE.DEFAULT
    }
  })()

  const id = (() => {
    if (!rolesSet.has(USER_ROLE.MERCHANT)) return memberInfoId

    const merchantId = userProfile?.roleDetail?.[USER_ROLE.MERCHANT]?.id
    if (!merchantId) {
      console.error('merchantId is not found')
      return memberInfoId
    }

    return merchantId
  })()

  return {
    role,
    id,
  }
}

export default useFollowParams
